"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrthoContractFrequency_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var OrthoContractFrequency_Factory = /** @class */ (function () {
    function OrthoContractFrequency_Factory() {
    }
    OrthoContractFrequency_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    OrthoContractFrequency_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return OrthoContractFrequency_Factory;
}());
exports.OrthoContractFrequency_Factory = OrthoContractFrequency_Factory;
